// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-administrator-new-tenant-administrator-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
}
.system-administrator-new-tenant-administrator-container{
    width: 32vw;
    opacity: 0;
    border-radius: 5px;
    margin-bottom: 2vh;
    background-color: white;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    transform: translateX(-100%);
    animation: system-administrator-new-tenant-administrator-container-fade-in 1s ease-in forwards;
}
@keyframes system-administrator-new-tenant-administrator-container-fade-in {
    from{
        opacity: 0;
        transform: translateX(-100%);
    }
    80%{
        opacity: 1;
        transform: translateX(6%);
    }
    to{
        opacity: 1;
        transform: translateX(0%);
    }
}
.system-administrator-new-tenant-administrator-header{
    color: white;
    margin: 0px;
    padding: 10px 25px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: 5px  5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.system-administrator-new-tenant-administrator-header h1{
    margin: 0px;
    font-size: 22px;
    font-weight: 600;
}
.system-administrator-new-tenant-administrator-header p{
    margin: 0px;
    cursor: pointer;
    font-size: 22px;
    font-weight: 400;
}
.system-administrator-new-tenant-administrator-body{
    max-height: 65vh;
    overflow: auto;
    box-sizing: border-box;
    padding: 0px 25px;
}
.system-administrator-new-tenant-administrator-body::-webkit-scrollbar{
    width: 4px;
}
.system-administrator-new-tenant-administrator-body::-webkit-scrollbar-thumb{
    border-radius: 4px;
    background-color: rgb(184, 184, 184);
}
.system-administrator-new-tenant-administrator-entry-container{
    position: relative;
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid gray;
    border-radius: 2px 2px 0px 0px;
    background-color: rgba(222, 229, 233,0.6);
}
.system-administrator-new-tenant-administrator-entry-container:focus-within{
    border-bottom: 2px solid rgb(119, 12, 12);
    background-color: rgb(221, 232, 238);
}
.system-administrator-new-tenant-administrator-entry-container p{
    margin: 0px;
    font-size: 12px;
    cursor: default;
}
.system-administrator-new-tenant-administrator-entry-container span{
    color: red;
}
.system-administrator-new-tenant-administrator-entry-container input{
    width: 100%;
    outline: none;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
}
.system-administrator-new-tenant-administrator-selected-country-display{
    display: flex;
    justify-content: space-between;
}
.system-administrator-new-tenant-administrator-selected-country-display p{
    font-size: 14px;
    margin: 2px 0px;
}
.system-administrator-new-tenant-administrator-selected-country-display .cancel-p{
    cursor: pointer;
    color: rgb(54, 54, 54);
}
.system-administrator-new-tenant-administrator-countries-browser{
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    right: 0;
    z-index: 1;
    display: none;
    overflow: auto;
    max-height: 17vh;
    background-color: white;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}
.system-administrator-new-tenant-administrator-countries-browser.active{
    display: block;
}
.system-administrator-new-tenant-administrator-countries-browser::-webkit-scrollbar{
    width: 4px;
}
.system-administrator-new-tenant-administrator-countries-browser::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: gray;
}
.system-administrator-new-tenant-administrator-countries-browser div{
    padding: 5px 16px;
    font-size: 14px;
    cursor: pointer;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    border: 1px solid rgb(250, 250, 250);
}
.system-administrator-new-tenant-administrator-countries-browser div:hover{
    background-color: rgb(221, 232, 238);
}
.system-administrator-new-tenant-administrator-buttons-container{
    margin: 16px 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right: 4px;
}
.system-administrator-new-tenant-administrator-buttons-container button{
    border: none;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
}
.system-administrator-new-tenant-administrator-buttons-container button.cancel{
    font-weight: 500;
    color: rgba(155, 30, 30, 0.952);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.system-administrator-new-tenant-administrator-buttons-container button.add.active{
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in-out;
}
.system-administrator-new-tenant-administrator-buttons-container button.add.active:hover{
    opacity: 0.9;
}
.system-administrator-new-tenant-administrator-buttons-container button.add.inactive{
    cursor: not-allowed;
    color: rgb(190, 190, 190);
}

/*#region Creating Tenant Administrator*/
.system-administrator-new-tenant-administrator-creating-container{
    text-align: center;
    padding: 10px 20px;
    padding-top: 20px;
    border-radius: 4px;
    background-color: white;
}
.system-administrator-new-tenant-administrator-creating-container div{
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
    animation: system-administrator-new-tenant-administrator-creating-spinner 0.8s linear infinite;
}
@keyframes system-administrator-new-tenant-administrator-creating-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.system-administrator-new-tenant-administrator-creating-container p{
    cursor: default;
    margin: 12px 0px;
    color: rgb(68, 68, 68);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
/*#endregion*/
/*#region Created Tenant Administrator*/
.system-administrator-new-tenant-administrator-created-container{
    position: relative;
    border-radius: 4px;
    background-color: white;
}
.system-administrator-new-tenant-administrator-created-details-container{
    padding: 10px 25px;
    padding-bottom: 15px;
}
.system-administrator-new-tenant-administrator-created-details-container p{
    cursor: default;
    margin: 15px 0px;
    color: rgb(48, 48, 48);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.system-administrator-new-tenant-administrator-created-details-container div{
    text-align: right;
}
.system-administrator-new-tenant-administrator-created-details-container div button{
    border: none;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    padding: 8px 20px;
    background-color: rgba(12, 107, 48, 0.952);
    transition: background-color 0.25s ease-in;
}
.system-administrator-new-tenant-administrator-created-details-container div button:hover{
    background-color: rgba(17, 134, 62, 0.952);
}
.system-administrator-new-tenant-administrator-created-escape-button-container{
    position: absolute;
    top: 0;
    right: -60px;
    cursor: pointer;
    font-family: lato, "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
}
.system-administrator-new-tenant-administrator-created-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.system-administrator-new-tenant-administrator-created-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.system-administrator-new-tenant-administrator-created-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}
/*#endregion*/
/*#region Error Creating Tenant Administrator*/
.system-administrator-new-tenant-administrator-create-error-container{
    position: relative;
    border-radius: 4px;
    background-color: white;
}
.system-administrator-new-tenant-administrator-create-error-details-container{
    padding: 10px 25px;
    padding-bottom: 15px;
}
.system-administrator-new-tenant-administrator-create-error-details-container p{
    cursor: default;
    margin: 15px 0px;
    color: rgb(48, 48, 48);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.system-administrator-new-tenant-administrator-create-error-details-container div{
    text-align: right;
}
.system-administrator-new-tenant-administrator-create-error-details-container div button{
    border: none;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    padding: 8px 20px;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in;
}
.system-administrator-new-tenant-administrator-create-error-details-container div button:hover{
    background-color: rgba(187, 29, 29, 0.952);
}
.system-administrator-new-tenant-administrator-create-error-escape-button-container{
    position: absolute;
    top: 0;
    right: -60px;
    cursor: pointer;
    font-family: lato, "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
}
.system-administrator-new-tenant-administrator-create-error-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.system-administrator-new-tenant-administrator-create-error-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.system-administrator-new-tenant-administrator-create-error-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}
/*#endregion*/`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/SystemAdministratorStyles/TenantAdministrators/NewTenantAdministrator.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,YAAY;IACZ,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,4DAA4D;IAC5D,4BAA4B;IAC5B,8FAA8F;AAClG;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,yBAAyB;IAC7B;IACA;QACI,UAAU;QACV,yBAAyB;IAC7B;AACJ;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,+BAA+B;IAC/B,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;AAC7C;AACA;IACI,yCAAyC;IACzC,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,4DAA4D;IAC5D,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,4DAA4D;AAChE;AACA;IACI,YAAY;IACZ,0CAA0C;IAC1C,8CAA8C;AAClD;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,6BAA6B;IAC7B,8FAA8F;AAClG;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,4DAA4D;AAChE;AACA,aAAa;AACb,uCAAuC;AACvC;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,4DAA4D;AAChE;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,eAAe;IACf,yEAAyE;AAC7E;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA,aAAa;AACb,8CAA8C;AAC9C;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,4DAA4D;AAChE;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,eAAe;IACf,yEAAyE;AAC7E;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA,aAAa","sourcesContent":[".system-administrator-new-tenant-administrator-parent-container{\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10;\n    height: 100vh;\n    width: 100vw;\n    background-color: rgba(0, 0, 0, 0.45);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.system-administrator-new-tenant-administrator-container{\n    width: 32vw;\n    opacity: 0;\n    border-radius: 5px;\n    margin-bottom: 2vh;\n    background-color: white;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    transform: translateX(-100%);\n    animation: system-administrator-new-tenant-administrator-container-fade-in 1s ease-in forwards;\n}\n@keyframes system-administrator-new-tenant-administrator-container-fade-in {\n    from{\n        opacity: 0;\n        transform: translateX(-100%);\n    }\n    80%{\n        opacity: 1;\n        transform: translateX(6%);\n    }\n    to{\n        opacity: 1;\n        transform: translateX(0%);\n    }\n}\n.system-administrator-new-tenant-administrator-header{\n    color: white;\n    margin: 0px;\n    padding: 10px 25px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    border-radius: 5px  5px 0px 0px;\n    background-color: rgba(155, 30, 30, 0.952);\n}\n.system-administrator-new-tenant-administrator-header h1{\n    margin: 0px;\n    font-size: 22px;\n    font-weight: 600;\n}\n.system-administrator-new-tenant-administrator-header p{\n    margin: 0px;\n    cursor: pointer;\n    font-size: 22px;\n    font-weight: 400;\n}\n.system-administrator-new-tenant-administrator-body{\n    max-height: 65vh;\n    overflow: auto;\n    box-sizing: border-box;\n    padding: 0px 25px;\n}\n.system-administrator-new-tenant-administrator-body::-webkit-scrollbar{\n    width: 4px;\n}\n.system-administrator-new-tenant-administrator-body::-webkit-scrollbar-thumb{\n    border-radius: 4px;\n    background-color: rgb(184, 184, 184);\n}\n.system-administrator-new-tenant-administrator-entry-container{\n    position: relative;\n    margin: 20px 0px;\n    padding: 4px 10px;\n    box-sizing: border-box;\n    border-bottom: 1px solid gray;\n    border-radius: 2px 2px 0px 0px;\n    background-color: rgba(222, 229, 233,0.6);\n}\n.system-administrator-new-tenant-administrator-entry-container:focus-within{\n    border-bottom: 2px solid rgb(119, 12, 12);\n    background-color: rgb(221, 232, 238);\n}\n.system-administrator-new-tenant-administrator-entry-container p{\n    margin: 0px;\n    font-size: 12px;\n    cursor: default;\n}\n.system-administrator-new-tenant-administrator-entry-container span{\n    color: red;\n}\n.system-administrator-new-tenant-administrator-entry-container input{\n    width: 100%;\n    outline: none;\n    border: none;\n    box-sizing: border-box;\n    background-color: transparent;\n}\n.system-administrator-new-tenant-administrator-selected-country-display{\n    display: flex;\n    justify-content: space-between;\n}\n.system-administrator-new-tenant-administrator-selected-country-display p{\n    font-size: 14px;\n    margin: 2px 0px;\n}\n.system-administrator-new-tenant-administrator-selected-country-display .cancel-p{\n    cursor: pointer;\n    color: rgb(54, 54, 54);\n}\n.system-administrator-new-tenant-administrator-countries-browser{\n    position: absolute;\n    top: calc(100% + 2px);\n    left: 0;\n    right: 0;\n    z-index: 1;\n    display: none;\n    overflow: auto;\n    max-height: 17vh;\n    background-color: white;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n}\n.system-administrator-new-tenant-administrator-countries-browser.active{\n    display: block;\n}\n.system-administrator-new-tenant-administrator-countries-browser::-webkit-scrollbar{\n    width: 4px;\n}\n.system-administrator-new-tenant-administrator-countries-browser::-webkit-scrollbar-thumb{\n    border-radius: 5px;\n    background-color: gray;\n}\n.system-administrator-new-tenant-administrator-countries-browser div{\n    padding: 5px 16px;\n    font-size: 14px;\n    cursor: pointer;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    border: 1px solid rgb(250, 250, 250);\n}\n.system-administrator-new-tenant-administrator-countries-browser div:hover{\n    background-color: rgb(221, 232, 238);\n}\n.system-administrator-new-tenant-administrator-buttons-container{\n    margin: 16px 25px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    padding-right: 4px;\n}\n.system-administrator-new-tenant-administrator-buttons-container button{\n    border: none;\n    cursor: pointer;\n    padding: 8px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    box-sizing: border-box;\n}\n.system-administrator-new-tenant-administrator-buttons-container button.cancel{\n    font-weight: 500;\n    color: rgba(155, 30, 30, 0.952);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.system-administrator-new-tenant-administrator-buttons-container button.add.active{\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in-out;\n}\n.system-administrator-new-tenant-administrator-buttons-container button.add.active:hover{\n    opacity: 0.9;\n}\n.system-administrator-new-tenant-administrator-buttons-container button.add.inactive{\n    cursor: not-allowed;\n    color: rgb(190, 190, 190);\n}\n\n/*#region Creating Tenant Administrator*/\n.system-administrator-new-tenant-administrator-creating-container{\n    text-align: center;\n    padding: 10px 20px;\n    padding-top: 20px;\n    border-radius: 4px;\n    background-color: white;\n}\n.system-administrator-new-tenant-administrator-creating-container div{\n    display: inline-block;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 2px solid rgba(155, 30, 30, 0.952);\n    border-top-color: transparent;\n    animation: system-administrator-new-tenant-administrator-creating-spinner 0.8s linear infinite;\n}\n@keyframes system-administrator-new-tenant-administrator-creating-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.system-administrator-new-tenant-administrator-creating-container p{\n    cursor: default;\n    margin: 12px 0px;\n    color: rgb(68, 68, 68);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n/*#endregion*/\n/*#region Created Tenant Administrator*/\n.system-administrator-new-tenant-administrator-created-container{\n    position: relative;\n    border-radius: 4px;\n    background-color: white;\n}\n.system-administrator-new-tenant-administrator-created-details-container{\n    padding: 10px 25px;\n    padding-bottom: 15px;\n}\n.system-administrator-new-tenant-administrator-created-details-container p{\n    cursor: default;\n    margin: 15px 0px;\n    color: rgb(48, 48, 48);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.system-administrator-new-tenant-administrator-created-details-container div{\n    text-align: right;\n}\n.system-administrator-new-tenant-administrator-created-details-container div button{\n    border: none;\n    color: white;\n    border-radius: 4px;\n    cursor: pointer;\n    padding: 8px 20px;\n    background-color: rgba(12, 107, 48, 0.952);\n    transition: background-color 0.25s ease-in;\n}\n.system-administrator-new-tenant-administrator-created-details-container div button:hover{\n    background-color: rgba(17, 134, 62, 0.952);\n}\n.system-administrator-new-tenant-administrator-created-escape-button-container{\n    position: absolute;\n    top: 0;\n    right: -60px;\n    cursor: pointer;\n    font-family: lato, \"Helvetica Neue\", Helvetica, Roboto, Arial, sans-serif;\n}\n.system-administrator-new-tenant-administrator-created-escape-button-container:hover button{\n    color: rgb(96, 96, 96);\n}\n.system-administrator-new-tenant-administrator-created-escape-button-container button{\n    border: none;\n    font-size: 20px;\n    padding: 10px 16px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: white;\n    color: rgb(175, 175, 175);\n    transition: color 0.25s ease;\n}\n.system-administrator-new-tenant-administrator-created-escape-button-container p{\n    margin: 5px 0px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 900;\n    cursor: pointer;\n    color: rgb(240, 240, 240);\n}\n/*#endregion*/\n/*#region Error Creating Tenant Administrator*/\n.system-administrator-new-tenant-administrator-create-error-container{\n    position: relative;\n    border-radius: 4px;\n    background-color: white;\n}\n.system-administrator-new-tenant-administrator-create-error-details-container{\n    padding: 10px 25px;\n    padding-bottom: 15px;\n}\n.system-administrator-new-tenant-administrator-create-error-details-container p{\n    cursor: default;\n    margin: 15px 0px;\n    color: rgb(48, 48, 48);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.system-administrator-new-tenant-administrator-create-error-details-container div{\n    text-align: right;\n}\n.system-administrator-new-tenant-administrator-create-error-details-container div button{\n    border: none;\n    color: white;\n    border-radius: 4px;\n    cursor: pointer;\n    padding: 8px 20px;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in;\n}\n.system-administrator-new-tenant-administrator-create-error-details-container div button:hover{\n    background-color: rgba(187, 29, 29, 0.952);\n}\n.system-administrator-new-tenant-administrator-create-error-escape-button-container{\n    position: absolute;\n    top: 0;\n    right: -60px;\n    cursor: pointer;\n    font-family: lato, \"Helvetica Neue\", Helvetica, Roboto, Arial, sans-serif;\n}\n.system-administrator-new-tenant-administrator-create-error-escape-button-container:hover button{\n    color: rgb(96, 96, 96);\n}\n.system-administrator-new-tenant-administrator-create-error-escape-button-container button{\n    border: none;\n    font-size: 20px;\n    padding: 10px 16px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: white;\n    color: rgb(175, 175, 175);\n    transition: color 0.25s ease;\n}\n.system-administrator-new-tenant-administrator-create-error-escape-button-container p{\n    margin: 5px 0px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 900;\n    cursor: pointer;\n    color: rgb(240, 240, 240);\n}\n/*#endregion*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
